import { render, staticRenderFns } from "./CommesaDistinta.vue?vue&type=template&id=1d4b4af6&"
import script from "./CommesaDistinta.vue?vue&type=script&lang=js&"
export * from "./CommesaDistinta.vue?vue&type=script&lang=js&"
import style0 from "./CommesaDistinta.vue?vue&type=style&index=0&id=1d4b4af6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports